import { render, staticRenderFns } from "./AddNewsletterArticleModal.vue?vue&type=template&id=384ca14e&scoped=true&"
import script from "./AddNewsletterArticleModal.vue?vue&type=script&lang=js&"
export * from "./AddNewsletterArticleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384ca14e",
  null
  
)

export default component.exports